<div class="wrapper">
    <div class="header"><h2>{{header}}</h2></div>
    <div class="progress">
        <p-progressBar mode="indeterminate"></p-progressBar>
    </div>
    <div class="details">{{details}}</div>
</div>